import React, { useEffect, useState, useCallback } from 'react';

// Subtle floating clouds in background - MORE VISIBLE
const FloatingClouds = () => {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
      {/* Clearly visible soft clouds scattered across the page */}
      <div className="absolute top-[0%] left-[0%] w-[600px] h-[300px] bg-stone-400/50 rounded-full blur-[100px] animate-cloud-drift" />
      <div className="absolute top-[5%] right-[0%] w-[500px] h-[250px] bg-pink-300/50 rounded-full blur-[90px] animate-cloud-drift-slow" style={{ animationDelay: '2s' }} />
      <div className="absolute top-[20%] left-[5%] w-[550px] h-[280px] bg-blue-300/45 rounded-full blur-[100px] animate-cloud-drift" style={{ animationDelay: '1s' }} />
      <div className="absolute top-[30%] right-[5%] w-[480px] h-[240px] bg-purple-300/50 rounded-full blur-[90px] animate-cloud-drift-slow" style={{ animationDelay: '3s' }} />
      <div className="absolute top-[45%] left-[0%] w-[520px] h-[260px] bg-amber-300/45 rounded-full blur-[100px] animate-cloud-drift" style={{ animationDelay: '4s' }} />
      <div className="absolute top-[55%] right-[0%] w-[560px] h-[280px] bg-teal-300/45 rounded-full blur-[90px] animate-cloud-drift-slow" style={{ animationDelay: '0.5s' }} />
      <div className="absolute top-[70%] left-[8%] w-[500px] h-[250px] bg-cyan-300/50 rounded-full blur-[100px] animate-cloud-drift" style={{ animationDelay: '2.5s' }} />
      <div className="absolute top-[80%] right-[5%] w-[450px] h-[225px] bg-pink-300/55 rounded-full blur-[90px] animate-cloud-drift-slow" style={{ animationDelay: '1.5s' }} />
    </div>
  );
};

// Cursor binary code effect
const CursorBinary = () => {
  const [binaries, setBinaries] = useState([]);
  
  const handleMouseMove = useCallback((e) => {
    const id = Date.now() + Math.random();
    const binary = Math.random() > 0.5 ? '1' : '0';
    
    setBinaries(prev => [...prev.slice(-25), {
      id,
      x: e.clientX + (Math.random() - 0.5) * 30,
      y: e.clientY + (Math.random() - 0.5) * 30,
      binary,
      opacity: 0.4 + Math.random() * 0.3,
    }]);
  }, []);
  
  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove);
    
    const cleanup = setInterval(() => {
      setBinaries(prev => prev.slice(1));
    }, 80);
    
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      clearInterval(cleanup);
    };
  }, [handleMouseMove]);
  
  return (
    <div className="fixed inset-0 pointer-events-none z-50">
      {binaries.map((item, index) => {
        const fadeOpacity = ((index + 1) / binaries.length) * item.opacity;
        
        return (
          <span
            key={item.id}
            className="absolute font-mono text-stone-400 select-none transition-opacity duration-200"
            style={{
              left: item.x,
              top: item.y,
              opacity: fadeOpacity,
              fontSize: `${12 + Math.random() * 8}px`,
              transform: 'translate(-50%, -50%)',
            }}
          >
            {item.binary}
          </span>
        );
      })}
    </div>
  );
};

const FuturisticBackground = () => {
  return (
    <>
      {/* Subtle cloud background */}
      <FloatingClouds />
      
      {/* Cursor binary */}
      <CursorBinary />
    </>
  );
};

export default FuturisticBackground;
